export enum AccountManagementObjectType {
  CheckList = "CheckList",
  KickOff = "KickOff",
  Feedback = "Feedback",
  PreBilanUpsell = "PreBilanUpsell",
  Satisfaction = "Satisfaction",
  Bilan = "Bilan",
  QuarterlyReview = "QuarterlyReview",
}

export enum AccountManagementTaskStatus {
  Planned = "Planned",
  Sent = "Sent",
  Completed = "Completed",
  ToModerate = "ToModerate",
  Published = "Published",
  Rejected = "Rejected",
  Cancelled = "Cancelled",
}

export enum AccountManagementTargetUserRole {
  Client = "Client",
  Freelancer = "Freelancer",
  CSM = "CSM",
}

export enum AccountManagementCommentObjectType {
  FeedbackClient = "FeedbackClient",
  FeedbackTalent = "FeedbackTalent",
  PreBilanUpsell = "PreBilanUpsell",
  QuarterlyReviewClient = "QuarterlyReviewClient",
  QuarterlyReviewTalent = "QuarterlyReviewTalent",
  SatisfactionClient = "SatisfactionClient",
  SatisfactionTalent = "SatisfactionTalent",
  BilanClient = "BilanClient",
  BilanTalent = "BilanTalent",
  CsmTalentComment = "CsmTalentComment",
  Other = "Other",
}

export interface AccountManagementTask {
  id: number;
  projectId: number;
  objectType: AccountManagementObjectType;
  targetUserId: number;
  targetUser: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };
  targetUserRole: AccountManagementTargetUserRole;
  scheduledDate: string;
  status: AccountManagementTaskStatus;
  isFullyAutomated: boolean;
  sendGridTemplateId?: string;
  emailSentAt?: string;
  completedAt?: string;
  sequenceNumber?: number;
}

export interface AccountManagementCommentUser {
  userId: number;
  user: {
    id: number;
    firstName: string;
    lastName: string;
  };
}

export interface AccountManagementComment {
  id: number;
  projectId: number;
  authorUserId: number;
  authorUser: {
    id: number;
    firstName: string;
    lastName: string;
  };
  objectType: AccountManagementCommentObjectType;
  /**
   * Sequence number of the linked AM task. Only used for object types that
   * have multiple occurrences per project (currently QuarterlyReviewClient
   * and QuarterlyReviewTalent — one comment per quarter).
   * Null/undefined for all other types.
   */
  sequenceNumber?: number | null;
  content: string;
  targetUsers: AccountManagementCommentUser[];
  createdAt: string;
  updatedAt?: string;
  project?: {
    id: number;
    name: string;
    projectNumber: string;
    company?: {
      legalName: string;
    };
  };
}

export interface CreateAccountManagementCommentRequest {
  objectType: AccountManagementCommentObjectType;
  content: string;
  targetUserIds: number[];
  /** Required for QuarterlyReviewClient/QuarterlyReviewTalent — identifies which quarter. */
  sequenceNumber?: number | null;
}

export interface UpdateAccountManagementCommentRequest {
  content: string;
}

export interface TransferCsmLeadRequest {
  newLeadUserId: number;
}

/**
 * "Commentaire CSM sur le talent" notes for a project.
 * Stored as ApplicationNote (with ProjectId) on the backend, but exposed here
 * so the AM tab can show the CSM Lead his previous talent comments.
 */
export interface CsmTalentCommentResponse {
  id: number;
  content: string;
  authorUserId: number;
  authorFullName?: string | null;
  createdAt: string;
}
